// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"dc181b76","389":"8c118cfb","752":"cda7ba6e","998":"d3e46c77"}[chunkId] + ".chunk.js";
};